document.addEventListener('DOMContentLoaded', function () {
    const items = document.querySelectorAll('.FloatGallery__item');

    if (!items.length) return;

    let ticking = false;

    function updateFloat() {
        const scroll = window.scrollY;

        items.forEach((item) => {
            const move = parseFloat(item.dataset.move || 0);
            const y = scroll * (move / 180);

            item.style.setProperty('--scroll-y', `${y}px`);
        });

        ticking = false;
    }

    function onScroll() {
        if (!ticking) {
            requestAnimationFrame(updateFloat);
            ticking = true;
        }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    updateFloat();
});